<template>
  <div class="AppFileManager" data-locator="upload-tray">
    <v-expansion-panels v-model="isOpen" class="AppFileManager__panels">
      <v-expansion-panel class="AppFileManager__panel">
        <v-expansion-panel-title class="AppFileManager__panel__header text-text-primary">
          <slot name="header"/>
          <template #actions>
            <AppButton icon size="small" class="AppFileManager__toggleButton overlay-close-button" data-locator="upload-tray-toggle-button">
              <app-material-icon
                name="keyboard_arrow_up"
                class="AppFileManager__modelIcon"
                :class="{'AppFileManager__modelIcon--open': computedIsOpen}"
              />
            </AppButton>
            <AppButton icon size="small" class="AppFileManager__cancelButton overlay-close-button" data-locator="upload-tray-close-button" @click.stop="$emit('cancel')">
              <app-material-icon name="close_small" size="lg"/>
            </AppButton>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="AppFileManager__panel__content">
          <slot name="content"/>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'
export default {
  name: 'AppFileManager',
  components: { AppButton },
  emits: ['cancel', 'minimize'],
  data () {
    return {
      isOpen: 0,
    }
  },
  computed: {
    computedIsOpen () {
      return typeof this.isOpen === 'number'
    },
  },
  watch: {
    computedIsOpen (isOpen) {
      if (!isOpen) {
        this.$emit('minimize')
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";
@import "@/scss/box-shadow-tokens";

@import "vuetify/settings";
@import "@/scss/elevation-tokens";

.AppFileManager {
  position: fixed;
  bottom: 20px;
  width: 100%;
  max-width: 378px;
  @include elevation('z-index-popover');
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    right: 20px;
  }

  &__panels,
  &__panel {
    border-radius: get-radius('border-radius-3') !important;
  }

  &__panels {
    @include box-shadow('box-shadow-medium');
  }

  &__panel {
    &__header {
      padding: 12px 20px;
      border-bottom: get-border();
      font-size: 14px;
      font-weight: 700;
    }
    &__content :deep(.v-expansion-panel-text__wrapper) {
      padding: 16px 20px;
    }
  }

  &__toggleButton,
  &__cancelButton {
    width: 28px;
    height: 28px;
  }

  &__modelIcon {
    transition: transform .3s;
    &--open {
      transform: rotate(180deg);
    }
  }
}
</style>
